'use client';
export { GlobalErrorPageTur as default } from '@svenskaspelab/nova-foundation/nextjs/pages';
